import 'antd/es/slider/style';
import React from 'react';
import styled from '@emotion/styled';

interface DragDropProductImageProps {
  nodePreview?: React.ReactNode;
}

export const ShowImage = (props: DragDropProductImageProps) => {
  const { nodePreview } = props;

  return (
    <>
      <StyledBox>
        <div className="onlyUploadAImage">{nodePreview}</div>
      </StyledBox>
    </>
  );
};

const StyledBox = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid #cfd1d4;
  background-color: #cfd1d4;
  padding-top: 10px;

  & .onlyUploadAImage {
    & .ant-upload-drag-container {
      display: block !important;
    }
    &.ant-upload.ant-upload-drag .ant-upload {
      padding: 0;
    }
  }
`;
